import type { BookingConfirmationSummary } from '@massilia/queries'

import { formatPrice } from '@/utils/format-price'

export interface PaymentConfirmationBookingData {
  customerEmail?: string
  bookingRef?: string
  customerPhone?: string
  depositAmountLabel?: string
  depositDeadlineLabel?: string
  remainingAmountLabel?: string
  totalAmountLabel?: string
}

export function buildPaymentConfirmationBookingDataFromSummary(
  summary: BookingConfirmationSummary | undefined,
  bookingRefFallback?: string
): PaymentConfirmationBookingData {
  if (!summary) {
    return { bookingRef: bookingRefFallback }
  }

  const totalAmountLabel = formatPrice(summary.totalPriceCents / 100)
  const depositAmountCents = summary.depositAmountCents
  const depositAmountLabel =
    depositAmountCents === undefined ? totalAmountLabel : formatPrice(depositAmountCents / 100)
  const remainingCents =
    depositAmountCents === undefined
      ? summary.totalPriceCents
      : summary.totalPriceCents - depositAmountCents
  const depositDeadlineLabel = summary.depositDeadline
    ? formatDate(summary.depositDeadline)
    : undefined

  return {
    customerEmail: summary.client.email ?? undefined,
    bookingRef: summary.bookingReference,
    customerPhone: summary.client.phone ?? undefined,
    depositAmountLabel,
    depositDeadlineLabel,
    remainingAmountLabel: formatPrice(remainingCents / 100),
    totalAmountLabel,
  }
}

function formatDate(isoDate: string): string {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) return isoDate
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date)
}
